import React, { useMemo } from 'react';
import AutocompleteField from './AutocompleteField';
import { formatPaymentOption } from 'api/administrador/refunds';

export default function PaymentAutocomplete({
  payments,
  value,
  inputValue,
  onInputChange,
  onSelect,
  isDisabled,
  isLoading,
}) {
  const filteredPayments = useMemo(() => {
    const term = inputValue.trim().toLowerCase();
    if (!term) return payments;
    return payments.filter((p) => {
      const id = String(p.id);
      const idPayment = String(p.id_payment || '').toLowerCase();
      return id.includes(term) || idPayment.includes(term);
    });
  }, [payments, inputValue]);

  return (
    <AutocompleteField
      label="Pago a devolver"
      isRequired
      placeholder={payments.length ? 'Buscar por ID de pago…' : 'No hay pagos elegibles'}
      value={inputValue}
      onChange={onInputChange}
      options={filteredPayments}
      onSelect={onSelect}
      getOptionLabel={formatPaymentOption}
      getOptionKey={(p) => p.id}
      isDisabled={isDisabled || !payments.length}
      isLoading={isLoading}
      emptyMessage={
        payments.length
          ? 'Ningún pago coincide con ese ID'
          : 'Este estudiante no tiene pagos elegibles para devolución'
      }
      minLength={0}
      debounceMs={200}
    />
  );
}
